<template>
    <lista-conversas-base
        tabela-id="tblMensRecebidas"
        modal-id="modal-conversa"
        :conversas="conversas"
        :campos="campos"
        :itens-por-pagina="itensPorPagina"
        :carregando="carregando"
        :conversa-ativa="conversaAtiva"
        :participantes="participantes"
        :deve-exibir-participantes="deveExibirParticipantes"
        :usuario-id="usuarioId"
        :usuario="usuario"
        @abrir-conversa="abrirConversa"
        @modal-hidden="fecharConversa"
        @novas-mensagens="atualizarContadorNovasMensagens"
        @mensagens-marcadas-como-lidas="onMensagensMarcadasComoLidas"
    />
</template>

<script>
import { ConversasMixin } from './mixins/ConversasMixin'
import ListaConversasBase from './components/ListaConversasBase.vue'
import { conversasHub } from './ConversasHub'

export default {
    mixins: [ConversasMixin],

    components: {
        ListaConversasBase
    },

    props: {
        deveCarregar: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'usuarioCriacao',
                    label: 'De',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'qtdNaoLidas',
                    label: 'Não Lidas',
                    sortable: true,
                    type: 'qtd'
                },
                {
                    key: 'assunto',
                    label: 'Assunto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'usuarioEmAtendimento',
                    label: 'Em Atendimento',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataCriacao',
                    label: 'Criada em',
                    sortable: true,
                    formatter: value => this.formatarData(value),
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ]
        }
    },

    computed: {
        modalId() {
            return 'modal-conversa'
        },

        tabelaId() {
            return 'tblMensRecebidas'
        }
    },

    async created() {
        await this.inicializarConexaoHub()
        if (this.deveCarregar) {
            this.carregarConversas()
        }
    },

    watch: {
        deveCarregar: {
            immediate: false,
            handler(novoValor) {
                if (novoValor && this.conversas.length === 0) {
                    this.carregarConversas()
                }
            }
        }
    },

    methods: {
        calcularTotalNaoLidas() {
            const totalNaoLidas = this.conversas.reduce(
                (total, conv) => total + (conv.qtdNaoLidas || 0),
                0
            )
            this.$emit('novas-mensagens', totalNaoLidas)
        },

        onUsuarioEmAtendimentoAtualizado({ conversaId, usuarioEmAtendimentoId, usuarioEmAtendimento }) {
            const conversa = this.conversas.find(c => c.id === String(conversaId))
            if (conversa) {
                conversa.usuarioEmAtendimento = usuarioEmAtendimento
                conversa.usuarioEmAtendimentoId = usuarioEmAtendimentoId
            }
        }
    }
}
</script>
